import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { BaseOperation } from 'src/app/perical/models/thermal-operation.model';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { formatUnitNumber } from 'src/app/shared/helpers/unit-number-format.helper';
import { InternalPressureProfileType, PericalLinkIPP } from '../../models/internal-pressure-profile.model';

interface PericalLinkIPPForm {
  type: InternalPressureProfileType.PERICALLINK;
  thermalOperation: Partial<BaseOperation>;
}

@Component({
    selector: 'app-perical-link-ipp',
    template: `
    <form [formGroup]="form.formGroup">
      <label for="thermalOperation">Thermal Operation</label>
      <app-units-select-input
        filter
        filterBy="name"
        inputId="thermalOperation"
        dataKey="id"
        [options]="thermalOperations"
        [formControlName]="form.formControlNames.thermalOperation"
        [optionLabelFormatter]="formatOperationOption"
        [unit]="userUnits?.shortLengths ?? 'in'"
        class="w-full"
        appendTo="body"
      ></app-units-select-input>
    </form>
    `,
    providers: subformComponentProviders(PericalLinkIppComponent),
    standalone: false
})
export class PericalLinkIppComponent implements AfterViewInit, OnChanges {

  @Input() thermalOperations: Partial<BaseOperation>[];
  @Input() userUnits: UserUnitsModel;

  public readonly formatOperationOption = (operation: Partial<BaseOperation>): string => {
    const unit = this.userUnits?.shortLengths ?? 'in';
    return (operation.name ?? '').replace(/\d+\.\d+/g, value =>
      formatUnitNumber(Number(value), unit, undefined, undefined, { [unit]: unit === 'in' ? 3 : 2 })
    );
  };

  public form = createForm<PericalLinkIPP, PericalLinkIPPForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.PERICALLINK),
      thermalOperation: new UntypedFormControl(null, Validators.required)
    },
    toFormGroup: (obj: PericalLinkIPP): PericalLinkIPPForm => {
      if (!obj) { return null;}
      return {
        type: InternalPressureProfileType.PERICALLINK,
        thermalOperation: !obj.thermalOperationId ? (!this.thermalOperations ? null : this.thermalOperations[0]) : this.thermalOperations.find(op => op.id === obj.thermalOperationId)
      };
    },
    fromFormGroup: (formValue: PericalLinkIPPForm): PericalLinkIPP => {
      const { thermalOperation, ...commonValues} = formValue;
      return { type: InternalPressureProfileType.PERICALLINK, thermalOperationId: thermalOperation.id, ...commonValues }
    }
  });

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.form.formGroup.controls.thermalOperation.value  && this.thermalOperations) {
        this.form.formGroup.controls.thermalOperation.setValue(this.thermalOperations[0]);
      }
    }, 100);
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (!this.form.formGroup.controls.thermalOperation.value  && this.thermalOperations) {
        this.form.formGroup.controls.thermalOperation.setValue(this.thermalOperations[0]);
      }
    }, 100);
  }

}
